<ngb-alert [hidden]="!show" [type]="'warning'" (closed)="close()">
  Your project is using an outdated notifier library. Please update to the
  current version to get new features like
  <b>Performance Monitoring</b>.
  <a class="alert-link" (click)="goToUpgradeNotifierDoc()"> Update now </a>
</ngb-alert>
